var map = {
	"./AQUA OPTIMA.png": 412,
	"./ARZUM.png": 2618,
	"./BEURER.png": 7736,
	"./BLACK & DECKER.png": 5511,
	"./BRAUN.png": 7946,
	"./DECAKILA.png": 8986,
	"./DI4.png": 6419,
	"./EGLO.png": 4244,
	"./ELEMENTS.png": 7103,
	"./EMUCA.png": 1686,
	"./FLUA.png": 5916,
	"./FOCUS.png": 2365,
	"./HAMA.png": 6689,
	"./LEIFHEIT.png": 4219,
	"./LENCO.png": 7596,
	"./MICHAEL KORS.png": 9019,
	"./ORAL B.png": 8760,
	"./PHILIPS.png": 7619,
	"./POLARBOX.png": 9939,
	"./Q&Q.png": 4313,
	"./REMINGTON.png": 5,
	"./RUSSELL HOBBS.png": 3580,
	"./SEVERIN.png": 5033,
	"./SOHENLE.png": 1612,
	"./TELEFUNKEN.png": 9756,
	"./UFESA.png": 7110,
	"./WAHL.png": 3840,
	"./vide.png": 6624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 352;